import * as Sentry from '@sentry/browser';
import { HttpClient } from '@sentry/integrations';
import { vrmConfig } from '@/config';

if (vrmConfig.sentry === true) {
    console.log('sentry initted');
    Sentry.init({
        debug: true,
        dsn: vrmConfig.sentryDsn,
        tracesSampleRate: 1,
        defaultIntegrations: false,
        integrations: [new HttpClient()],
    });
}
